// extracted by mini-css-extract-plugin
export var actions = "CoinFlip-module--actions--JX2UN";
export var coin = "CoinFlip-module--coin--FHm5K";